import MobileLogo from '../src/MobileLogo';
export default MobileLogo;
